//@flow
import React from 'react';
import {colors} from '../../../assets/styles/colors';

type Props = {
  message: string,
};

const urlRegex = /https?:\/\/[^\s]+/g;

export default function WhatsappWebFormatter(props: Props) {
  const {message} = props;

  const splitMessage = message.split(/(\s+)/);

  let formattedMessage = [];
  for (let i = 0; i < splitMessage.length; i++) {
    const item = splitMessage[i];

    if (!item) continue;

    if (item.startsWith('*') && item.endsWith('*') && item.length > 1) {
      formattedMessage.push(<b key={i}>{item.slice(1, -1)}</b>);
    } else if (item.startsWith('_') && item.endsWith('_') && item.length > 1) {
      formattedMessage.push(<i key={i}>{item.slice(1, -1)}</i>);
    } else if (item.startsWith('~') && item.endsWith('~') && item.length > 1) {
      formattedMessage.push(<s key={i}>{item.slice(1, -1)}</s>);
    } else if (item.startsWith('`') && item.endsWith('`') && item.length > 1) {
      formattedMessage.push(<code key={i}>{item.slice(1, -1)}</code>);
    } else if (item.match(urlRegex)) {
      formattedMessage.push(
        <a
          key={i}
          href={item}
          target="_blank"
          rel="noopener noreferrer"
          style={{color: colors.primary}}
        >
          {item}
        </a>
      );
    } else {
      formattedMessage.push(
        item.split('\n').map((line, index, arr) => (
          <React.Fragment key={`${i}-${index}`}>
            {line}
            {index < arr.length - 1 ? <br /> : ''}
          </React.Fragment>
        ))
      );
    }
  }

  return <>{formattedMessage}</>;
}
